const routes = {
  login: '/login',
  signup: '/login/signup',
  newPassword: '/login/new-password',
  customers: '/customers',
  deletedCustomers: '/customers/deleted',
  customer: (id: string, type: string, code?: string | null) =>
    `/customers/${id}?type=${type}${code ? `&code=${code}` : ''}`,
  newShop: (id: string, type: string, code: string | null) =>
    `/customers/${id}/shop/new?type=${type}${code ? `&code=${code}` : ''}`,
  newWarehouse: (id: string, type: string, code: string | null) =>
    `/customers/${id}/warehouse/new?type=${type}${code ? `&code=${code}` : ''}`,
  shop: (
    id: string,
    shopId: string,
    type: string,
    shopModel?: string,
    code?: string | null | undefined
  ) =>
    `/customers/${id}/shop/${shopId}?type=${type}&shopModel=${shopModel}${
      code ? `&code=${code}` : ''
    }`,
  warehouse: (id: string, warehouseId: string, type: string, code?: string) =>
    `/customers/${id}/warehouse/${warehouseId}?type=${type}&code=${code}`,
  catalogue: '/catalogue',
  users: '/users',
  orders: '/catalogue/orders',
  forbidden: '/forbidden',
  userView: (id: string) => `/users/${id}`,
  budget: '/catalogue/budget',
  sizeScales: '/catalogue/size-scales',
  notifications: '/catalogue/notifications',
  notificationsCategories: '/catalogue/notifications-categories',
  seasons: '/catalogue/seasons-and-zones/seasons',
  zones: '/catalogue/seasons-and-zones/zones',
  add: '/new',
};

const paths = {
  edit: 'edit',
  newUser: 'new-user',
  manage: 'manage',
  shop: 'shop/:shopId',
  warehouse: 'warehouse/:warehouseId',
  add: 'new',
  seasons: 'seasons',
  zones: 'zones',
};

export type RouteName = keyof typeof routes;
export type PathName = keyof typeof paths;

export { paths, routes };
